import { FaFilter as FilterIcon } from 'react-icons/fa';

export default FilterIcon;
